import { createContext, useContext } from 'react';

export interface DrawerLayoutContext {
  isOpened: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  /**
   * Valid CSS `string` that could be used in CSS rules like `width` or `min-width`;
   */
  collapsedDrawerWidth: string;
  /**
   * Valid CSS `string` that could be used in CSS rules like `width` or `min-width`;
   */
  expandedDrawerWidth: string;
  setDisplayToggle: React.Dispatch<React.SetStateAction<boolean>>;
}

const DrawerLayoutContext = createContext<DrawerLayoutContext>(null);

export const DrawerLayoutProvider = DrawerLayoutContext.Provider;

export const useDrawerLayoutContext = () => {
  const drawerLayoutContext = useContext(DrawerLayoutContext);

  if (!drawerLayoutContext) {
    throw new Error(
      'useDrawerLayoutContext must be used within <DrawerLayoutContext.Provider> or <DrawerLayoutProvider>',
    );
  }

  return drawerLayoutContext;
};
